import { createStore, applyMiddleware } from "redux";
import RootReducer from "./reducers/RootReducer";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

const persistConfig = {
  key: "reducer",
  storage: storage,
  whitelist: ["user", "general", "price", "kyc", "coinWithdraw"], // or blacklist to exclude specific reducers
};
const presistedReducer = persistReducer(persistConfig, RootReducer);
const store = createStore(
  presistedReducer,
  composeWithDevTools(applyMiddleware(thunk))
);
const persistor = persistStore(store);
export { persistor, store };

export type RootStore = ReturnType<typeof RootReducer>;

// export default Store;
